import { ConsentServiceProvider, useConsentService } from "@aviv-csnt/react";
import type { PropsWithChildren } from "react";

const DATADOG_CONSENT_ID = "Xl0HIOViY";

/**
 * Facade in front of "@aviv-csnt/react" to handle a possible double implementation for the UserCentrics v3 migration
 */

export const createConsentContext = (id: string) => ({
  Provider: ({ children }: PropsWithChildren) => (
    <ConsentServiceProvider id={id}>{children}</ConsentServiceProvider>
  ),
  useUserConsent,
});

export const useConsentServiceStatus = (id?: string) => {
  const consentService = useConsentService();

  if (!id) return false;

  return Boolean(consentService.consentItems[id]?.consent);
};

export function createConsentServiceHook<
  T extends keyof ReturnType<typeof useConsentService>["consentItems"],
>(consentID: T): () => boolean | undefined {
  return () => {
    const consentService = useConsentService();
    const consentItem = consentService.consentItems[consentID];

    if (!consentService.isConsentGranted) {
      return;
    }

    return consentItem?.consent;
  };
}

export const useUserConsent = () => useConsentService().isConsentGranted;

export const useDatadogConsent = () =>
  useConsentServiceStatus(DATADOG_CONSENT_ID);
